module.exports = __webpack_public_path__ + "static/media/dashboard-default-large.6dc6c31f.png";